import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { SharedModule } from '@app/sharedModule/shared.module';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { StorybookModule } from '@app/storybook/storybook.module';
import { NgApexchartsModule } from 'ng-apexcharts';
import { FeaturesModule } from '@app/features/features.module';
// PAGES
import { FulfillPageModule } from './workspace/fulfill/fulfill.module';
import { SettingsModule } from './settings/settings.module';
import { SearchModule } from './search/search.module';
import { CarriersModule } from '@pages/delivery-service/carriers.module';
import { AssignModule } from '@pages/workspace/assign/assign.module';
import { TrackModule } from '@pages/workspace/track/track.module';
import { AnalyticsDashboardModule } from '@app/dashboard/dashboard/dashboard.module';
import { CheckoutAppModule } from '@pages/checkout-app/checkout.app.module';
import { DeletedOrdersModule } from '@pages/deleted-orders/deleted-orders.module';
import { NewAnalyticsComponent } from './new-analytics/new-analytics.component';
import { AbTestResultsComponent } from './abtest-results/abtest-results.component';
import { PDQLabsComponent } from './pdq-labs/pdq-labs.component';
import { AllTestsDashboardComponent } from './pdq-labs/all-tests-dashboard/all-tests-dashboard.component';
import { MaxxAnalysisTriggerComponent } from './pdq-labs/all-tests-dashboard/components/maxx-analysis-trigger/maxx-analysis-trigger.component';
import { MaxxAnalysisPanelComponent } from './pdq-labs/all-tests-dashboard/components/maxx-analysis-panel/maxx-analysis-panel.component';
import { CustomDashboardComponent } from './custom-dashboard/custom-dashboard.component';
import { OrderEditingModule } from './order-editing/order-editing.module';
import { OneClickUpsellModule } from './one-click-upsell/one-click-upsell.module';
import { EngageModule } from './engage/engage.module';
import { RouterModule } from '@angular/router';
import { StrategyCatalogComponent } from './strategy-catalog/strategy-catalog.component';
import { StrategyDetailsComponent } from './strategy-catalog/components/strategy-details/strategy-details.component';
import { BookmarksComponent } from './strategy-catalog/components/bookmarks/bookmarks.component';
import { RoadmapSectionComponent } from './strategy-catalog/components/roadmap-section/roadmap-section.component';
import { StrategyCommentsComponent } from './strategy-catalog/components/strategy-comments/strategy-comments.component';
import { ConnectTestComponent } from './strategy-catalog/components/connect-test/connect-test.component';
import { SkeletonStrategyCatalogComponent } from '@app/storybook/components/skeleton/skeleton-strategy-catalog/skeleton-strategy-catalog.component';
import { SkeletonStrategyDetailsComponent } from '@app/storybook/components/skeleton/skeleton-strategy-details/skeleton-strategy-details.component';
import { StrategyEmbedLinkComponent } from './strategy-catalog/strategy-embed-link/strategy-embed-link.component';
import { CreateCustomStrategyDialogComponent } from './strategy-catalog/components/create-custom-strategy-dialog/create-custom-strategy-dialog.component';
import { ImpactDashboardComponent } from './impact-dashboard/impact-dashboard.component';
import { ImpactDashboardAfterAbTestWinnerComponent } from './impact-dashboard/impact-dashboard-after-abtest-winner/impact-dashboard-after-abtest-winner.component';
import { ImpactDashboardBeforeAnyAbTestWinnerComponent } from './impact-dashboard/impact-dashboard-before-any-abtest-winner/impact-dashboard-before-any-abtest-winner.component';
import { RevenueUpliftProgressChartComponent } from './impact-dashboard/impact-dashboard-after-abtest-winner/revenue-uplift-progress-chart/revenue-uplift-progress-chart.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    StorybookModule,
    FeaturesModule,
    SharedModule,
    NgApexchartsModule,
    FulfillPageModule,
    SettingsModule,
    SearchModule,
    CarriersModule,
    AssignModule,
    OrderEditingModule,
    TrackModule,
    AnalyticsDashboardModule,
    CheckoutAppModule,
    DeletedOrdersModule,
    EngageModule,
    RouterModule,
    StrategyEmbedLinkComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  exports: [],
  declarations: [
    NewAnalyticsComponent,
    AbTestResultsComponent,
    PDQLabsComponent,
    AllTestsDashboardComponent,
    MaxxAnalysisTriggerComponent,
    MaxxAnalysisPanelComponent,
    CustomDashboardComponent,
    StrategyCatalogComponent,
    StrategyDetailsComponent,
    BookmarksComponent,
    RoadmapSectionComponent,
    StrategyCommentsComponent,
    ConnectTestComponent,
    CreateCustomStrategyDialogComponent,
    SkeletonStrategyCatalogComponent,
    SkeletonStrategyDetailsComponent,
    ImpactDashboardComponent,
    ImpactDashboardBeforeAnyAbTestWinnerComponent,
    ImpactDashboardAfterAbTestWinnerComponent,
    RevenueUpliftProgressChartComponent,
  ],
})
export class PagesModule {}
